import developerImage from "./assets/images/developer.jpg";

const profile = {
  name: "Kwabena Asante",
  role: "Software Developer & Founder of Quabcore",
  location: "Canada",
  photo: developerImage,
  intro:
    "I build cloud-native backend systems in Python, Go and TypeScript, and I contribute to open source.",
};

const about =
  "I am an AWS Certified Developer with experience designing and building software, from small desktop applications to large-scale cloud-native architectures. More recently, I have been building AI agentic solutions: LLM-powered agents that use tools, reason over data and automate multi-step workflows end to end. I use a broad set of engineering skills to automate processes and improve performance and security, and I am committed to continuous learning.";

const experience = [
  { role: "Founder", company: "Quabcore Technologies", date: "2025 – Present" },
  { role: "Software Developer", company: "Geotab", date: "2024 – 2025" },
  { role: "Backend Lead", company: "mPharma", date: "2019 – 2024" },
  { role: "Software Developer", company: "ESW Capital", date: "2018 – 2019" },
  { role: "Consultant", company: "Ampersand Technologies Ltd", date: "2018 – 2019" },
  { role: "Software Developer", company: "Bsystems Limited", date: "2014 – 2018" },
];

const projects = [
  {
    name: "Zebrok",
    description: "Brokerless task queue for Python based on ZeroMQ.",
    link: "https://github.com/kaypee90/zebrok",
  },
  {
    name: "Awesome Open Standards",
    description: "A curated list of popular open standards.",
    link: "https://github.com/kaypee90/awesome-open-standards",
  },
  {
    name: "Dependabot Wizard",
    description: "Streamlines setting up basic Dependabot configurations for GitHub projects.",
    link: "https://github.com/kaypee90/dependabot-wizard",
  },
  {
    name: "Exp. Query Accelerator",
    description: "Experimental server for caching database fetch queries.",
    link: "https://github.com/kaypee90/exp-query-accelerator",
  },
  {
    name: "DHC Server",
    description:
      "Go application that consumes data captured by the Django Health Check Monitoring library via a REST API.",
    link: "https://github.com/kaypee90/dhc-server",
  },
  {
    name: "Uno Web Framework",
    description: "Experimental web framework that uses a radix tree for routing.",
    link: "https://github.com/kaypee90/unoframework",
  },
];

const skills = ["Python", "TypeScript / JavaScript", "Go", "C#", "SQL", "AWS"];

const education = [
  {
    title: "MBA, Information Systems Management",
    school: "International Business University, Canada",
  },
  {
    title: "BSc Mathematics",
    school: "Kwame Nkrumah University of Science and Technology, Ghana",
  },
];

const certifications = [
  { title: "AWS Certified Developer – Associate", issuer: "Amazon Web Services" },
  { title: "Google Cybersecurity Professional Certificate (v2)", issuer: "Coursera" },
];

const links = [
  { label: "GitHub", url: "https://github.com/kaypee90" },
  { label: "LinkedIn", url: "https://www.linkedin.com/in/kwabena-asante-9b006477" },
  { label: "Quabcore", url: "https://quabcore.com" },
];

export {
  profile,
  about,
  experience,
  projects,
  skills,
  education,
  certifications,
  links,
};
